var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconCart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M32.07 35.734H4.302a3.59 3.59 0 0 1-3.579-3.579V4.387A3.59 3.59 0 0 1 4.303.808H32.07a3.59 3.59 0 0 1 3.58 3.579v27.768a3.589 3.589 0 0 1-3.58 3.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M7.92 15.586v0l1.684 8.094v0h14.123v0l2.352-8.061a.858.858 0 0 0-.761-1.254h-1.892v0H8.698a.858.858 0 0 0-.777 1.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M21.924 25.107a1.427 1.427 0 1 1-2.854 0 1.427 1.427 0 0 1 2.854 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M14.15 25.107a1.427 1.427 0 1 1-2.855 0 1.427 1.427 0 0 1 2.855 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M11.296 14.816v0l1.427 8.864v0h7.773v0l2.93-9.315v0l1.503-3.455v0l3.605-.902v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M8.636 16.844h17.542"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M8.636 20.224h16.1"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_cart.91cfd9b4.svg";
export { ForwardRef as ReactComponent };